/** Gets the default audio input stream by finding the default device. */
export async function getDefaultAudioStream(devices) {
    const defaultAudioInput = devices.find((device) => device.kind === 'audioinput' && device.deviceId === 'default');
    return await navigator.mediaDevices.getUserMedia({
        audio: defaultAudioInput ? { deviceId: { exact: defaultAudioInput.deviceId } } : true,
    });
}
//# sourceMappingURL=microphone.js.map